<template>
  <div class="flex middle column">
    <div class="w1200 w100">
      <section class="grid-flex w100 center column middle">
        <h2>Estamos te redirecionando. Aguarde!</h2>
        <div class="margin-top-l">
          <router-link v-if="flow && flow == 'whatsapp'" :to="{ name: 'SubscriptionWhats', params: {} }">Clique Aqui caso você não seja redirecionado!</router-link>
          <router-link v-else-if="flow && flow == 'cliente'" :to="{ name: 'SubscriptionAccount', params: {} }">Clique Aqui caso você não seja redirecionado!</router-link>
          <router-link v-else :to="{ name: 'Subscription', params: {} }">Clique Aqui caso você não seja redirecionado!</router-link>
        </div>
      </section>
    </div>
  </div>
</template>

<script>

import { mapState } from "vuex";
export default {
  name: "subscription-redirect",
  components: {},
  props: ['flow'],
  data() {
    return {
    };
  },
  mounted() {
    if (this.flow  && this.flow == "whatsapp") {
      setTimeout(() => {
        this.$router.push({ name: "SubscriptionWhats" });
      }, 1000)

      return
    }

    if (this.flow  && this.flow == "cliente") {
      setTimeout(() => {
        this.$router.push({ name: "SubscriptionAccount" });
      }, 1000)
      
      return
    }

    setTimeout(() => {
      this.$router.push({ name: "Subscription" });
    }, 1000)
  },
  computed: {
      ...mapState({
          account: (state) => state.account,
      }),
  },
  methods: {

  },
};
</script>

<style lang="scss" scoped>

</style>
